<div class="field-display" *ngIf="value">
  <div class="json-display">{{ formattedJson }}</div>
  <button type="button" mat-icon-button
      class="field-copy-button"
      matTooltip="Copy"
      [cdkCopyToClipboard]="value"
      (cdkCopyToClipboardCopied)="onCopyToClipboard.emit('Field value was copied to clipboard.')"
      (click)="$event.stopPropagation()">
      <mat-icon>content_copy</mat-icon>
  </button>
</div>
